<template>
  <el-card
    :body-style="{
      padding: '0px',
      display: 'inline-block',
    }"
    class="img-card">
    <img
      :src="url"
      @click="imgDialog = true"
      :style="{ 'max-width': `${maxWidth}px` }"
      class="img-card--image">
    <el-dialog
      class="img-card__dialog"
      :visible.sync="imgDialog">
      <img :src="url" class="img-card__dialog--img">
    </el-dialog>
  </el-card>
</template>

<script>
export default {
  name: 'imgCard',
  props: {
    url: {
      default: '',
      type: String,
    },
    maxWidth: {
      type: Number,
    },
  },
  data() {
    return {
      imgDialog: false,
    };
  },
};
</script>

<style lang="scss" scoped>
.img-card {
  vertical-align: top;
  display: inline-block;
  &--image {
    display: block;
    &:hover {
      cursor: pointer;
      opacity: 0.65;
    }
  }
  &__dialog {
    :deep(.el-dialog) {
      width: auto;
      max-width: 800px;
    }
    :deep(.el-dialog__body) {
      max-width: 800px;
    }
    &--img {
      width: 100%;
      max-width: 800px;
    }
  }
}
</style>
